const MANAGE_COOKIES = 'MANAGES_COOKIES';

export const manageCookies = cookiesPermissions => ({
    type: MANAGE_COOKIES,
    cookiesPermissions
});

const _getInitialState = () => ({
    googleAnalytics:  false,
    mandatoryCookies: true
});

export const reducer = (state = _getInitialState(), action = '') => {
    switch (action.type) {
    case MANAGE_COOKIES:
        return {
            ...state,
            googleAnalytics: action.cookiesPermissions.googleAnalytics
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/cookiesManager.js